import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Card, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import Step from './step';
import './trackingSchedule.scss';

class TrackingSchedule extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    this.handleClose();
  }

  componentDidUpdate(prevProps) {
    const {orderSequence} = this.props;
    if (orderSequence && orderSequence !== prevProps.orderSequence) {
      this.props.getOrderTrackingSchedule(orderSequence);
    }
  }

  handleClose() {
    this.props.selectOrderForTrackingSchedule('');
    if (this.props.parentProps) {
      const {userAgency, orderType, orderCode, user, partCode, status, dealer, agency} = this.props.parentProps;
      const userDealer = userAgency.dealerID;
      this.props.getDealersOrdersList({
        orderType,
        orderCode,
        user,
        partCode,
        status,
        dealer,
        agency,
        userDealer,
      });
    }
  }

  getPreviousDate(steps, index) {
    return index > 0 ? steps[index - 1].tentativeDate : null;
  }

  renderTrackingSteps() {
    const {loading, creating, steps} = this.props;

    if (loading || creating) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return steps.map((step, index) => {
      return <Step key={index} step={step} previousDate={this.getPreviousDate(steps, index)} />;
    });
  }

  render() {
    const {isOpen} = this.props;

    return (
      <Modal
        className='tracking-schedule-modal'
        dimmer
        closeIcon
        size='fullscreen'
        closeOnDimmerClick={false}
        open={isOpen}
        onClose={this.handleClose}
        trigger={<span />}
      >
        <Modal.Header>
          <h2>Tracking</h2>
        </Modal.Header>
        <Modal.Content>
          <div className='dealer-orders-tracking-schedule'>
            <Card raised fluid className='tracking-body'>
              <Table className='full-table'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width='4'>Proceso</Table.HeaderCell>
                    <Table.HeaderCell width='2'>Fecha Real</Table.HeaderCell>
                    <Table.HeaderCell width='2'>ETA Actualizada</Table.HeaderCell>
                    <Table.HeaderCell width='2'>Estado</Table.HeaderCell>
                    <Table.HeaderCell width='6'>Observaciones</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{this.renderTrackingSteps()}</Table.Body>
              </Table>
            </Card>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'orderSequence': state.trackingSchedule.selectedOrder,
    'loading': state.trackingSchedule.loading,
    'creating': state.trackingSchedule.creating,
    'steps': state.trackingSchedule.steps,
    'isOpen': state.trackingSchedule.isOpen,
  };
};

const {selectOrderForTrackingSchedule, getOrderTrackingSchedule, getDealersOrdersList} = Actions;

export default connect(mapStateToProps, {
  selectOrderForTrackingSchedule,
  getOrderTrackingSchedule,
  getDealersOrdersList,
})(TrackingSchedule);
